import { useTranslation } from "react-i18next";
import { UseFormReturn } from "react-hook-form";
import { Box, Link, Stack, SvgIcon, Theme } from "@mui/material";
import CheckboxInput from "src/components/Inputs/CheckboxInput";
import { TermsFormValues } from "src/pages/SmartCharging/CompCheck/Terms";

interface TermsInputsFormProps {
  form: UseFormReturn<TermsFormValues, any, undefined>;
}

const TermsInputsForm = ({ form }: TermsInputsFormProps) => {
  const { t } = useTranslation();

  return (
    <Stack gap={2}>
      <CheckboxInput
        control={form.control}
        icon={
          <SvgIcon
            sx={{
              width: "16px",
              height: "16px",
            }}
          >
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 4.75C1 3.09315 2.34315 1.75 4 1.75H12C13.6569 1.75 15 3.09315 15 4.75V12.75C15 14.4069 13.6569 15.75 12 15.75H4C2.34315 15.75 1 14.4069 1 12.75V4.75Z"
                fill="white"
              />
              <path
                d="M1 4.75C1 3.09315 2.34315 1.75 4 1.75H12C13.6569 1.75 15 3.09315 15 4.75V12.75C15 14.4069 13.6569 15.75 12 15.75H4C2.34315 15.75 1 14.4069 1 12.75V4.75Z"
                stroke="#2E2E2E"
                strokeWidth="2"
              />
            </svg>
          </SvgIcon>
        }
        checkedIcon={
          <SvgIcon sx={{ width: "16px", height: "16px" }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M0 6C0 2.68629 2.68629 0 6 0H10C13.3137 0 16 2.68629 16 6V10C16 13.3137 13.3137 16 10 16H6C2.68629 16 0 13.3137 0 10V6Z"
                fill="#383838"
              />
              <path
                d="M4.5 9L7 11L11.5 5"
                stroke="#E5E5E5"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </SvgIcon>
        }
        label={
          <Box
            sx={(theme: Theme) => ({
              fontWeight: 400,
              fontSize: "14px",
              lineHeight: "20px",
              fontFamily: "Inter",
              color: theme.palette.mainFont.primary,
            })}
          >
            {t("page.wallboxTerms.formFields.checkbox1.label1")}
            <Link
              sx={(theme) => ({
                color: theme.palette.app.secondaryFont,
                textDecoration: "underline",
              })}
              href="https://www.lichtblick.de/veroeffentlichungen/"
              target="_blank"
            >
              {t("page.wallboxTerms.formFields.checkbox1.link1")}
            </Link>
            {t("page.wallboxTerms.formFields.checkbox1.label2")}
            <Link
              sx={(theme) => ({
                color: theme.palette.app.secondaryFont,
                textDecoration: "underline",
              })}
              href="https://www.lichtblick.de/veroeffentlichungen/widerrufsbelehrung/"
              target="_blank"
            >
              {t("page.wallboxTerms.formFields.checkbox1.link2")}
            </Link>
            {t("page.wallboxTerms.formFields.checkbox1.label3")}
            <Link
              sx={(theme) => ({
                color: theme.palette.app.secondaryFont,
                textDecoration: "underline",
              })}
              href="https://www.lichtblick.de/datenschutz/"
              target="_blank"
            >
              {t("page.wallboxTerms.formFields.checkbox1.link3")}
            </Link>
            {t("page.wallboxTerms.formFields.checkbox1.label4")}
          </Box>
        }
        name="agb"
      />
    </Stack>
  );
};

export default TermsInputsForm;
